/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'List': {
    width: 16,
    height: 16,
    viewBox: '0 0 28 28',
    data: '<path pid="0" d="M7.172 19.565v2.172H5v-2.172h2.172zm15.314 0c.595 0 1.077.482 1.077 1.077v.018c0 .595-.482 1.077-1.077 1.077h-11.94a1.077 1.077 0 01-1.077-1.077v-.018c0-.595.482-1.077 1.077-1.077h11.94zM7.172 12.782v2.173H5v-2.173h2.172zm15.314 0c.595 0 1.077.483 1.077 1.078v.017c0 .595-.482 1.078-1.077 1.078h-11.94a1.077 1.077 0 01-1.077-1.078v-.017c0-.595.482-1.078 1.077-1.078h11.94zM7.172 6v2.172H5V6h2.172zm15.314 0c.595 0 1.077.482 1.077 1.077v.018c0 .595-.482 1.077-1.077 1.077h-11.94a1.077 1.077 0 01-1.077-1.077v-.018C9.469 6.482 9.95 6 10.546 6h11.94z"/>'
  }
})
